/**
 * OpenAPI document-level Scalar extensions.
 *
 * Applied on the root API description (OpenAPI `info` or document root). Includes workspace metadata,
 * environments, navigation state, registry sync fields, and document lifecycle flags.
 */
export { XInternal } from './x-internal.js';
export { XOriginalAasVersion } from './x-original-aas-version.js';
export { XOriginalOasVersion } from './x-original-oas-version.js';
export { XScalarEnvVar, XScalarEnvironment, XScalarEnvironments } from './x-scalar-environments.js';
export { XScalarIcon } from './x-scalar-icon.js';
export { XScalarIgnore } from './x-scalar-ignore.js';
export { XScalarIsDirty } from './x-scalar-is-dirty.js';
export { XScalarLinks } from './x-scalar-links.js';
export { XScalarNavigation } from './x-scalar-navigation.js';
export { XScalarOriginalDocumentHash } from './x-scalar-original-document-hash.js';
export { XScalarOriginalSourceUrl } from './x-scalar-original-source-url.js';
export { XScalarRegistryMeta } from './x-scalar-registry-meta.js';
export { XScalarSdkInstallation } from './x-scalar-sdk-installation.js';
export { XScalarWatchMode } from './x-scalar-watch-mode.js';
export { XTags } from './x-tags.js';
